import api from './api';

const UserHistoryDataProvider = {
    getUserHistory(params = {}) {
        return api.query('crmtt/api/History',{params})
    },
}

export default UserHistoryDataProvider